<template>
  <div class="agent-management">
    <el-card class="mb-4" shadow="never">
      <!-- 查询条件 -->
      <el-form :model="searchForm" inline>
        <el-form-item label="代理名称">
          <el-input placeholder="请输入代理名称" v-model="searchForm.agent_name"></el-input>
        </el-form-item>
        <el-form-item label="代理账号">
          <el-input placeholder="请输入代理账号" v-model="searchForm.username"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="mb-4" shadow="never">
      <div class="toolbar">
        <el-button type="primary" @click="showAddModal">新增</el-button>
      </div>
      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
        <el-table-column prop="id" label="代理ID" width="80" />
        <el-table-column prop="agent_name" label="代理名称" />
        <el-table-column prop="store_count" label="商户数量" />
        <el-table-column prop="username" label="代理账号" />
        <el-table-column prop="dianshu" label="点数" />
        <el-table-column prop="status" label="是否关闭" :formatter="is_openFormatter" />
        <el-table-column prop="out_date" label="过期时间" :formatter="dateFormatter" />
        <el-table-column prop="addtime" label="添加时间" :formatter="datetimeFormatter" />
        <el-table-column prop="uptime" label="更新时间" :formatter="datetimeFormatter" />
        <el-table-column label="操作" width="200">
          <template #default="{ row }">
            <el-link type="primary" @click="showEditModal(row)">编辑</el-link>
            <el-link type="success" style="margin-left:8px;" @click="showRechargeModal(row)">充值</el-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[15, 30, 50]" :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="isEdit ? '编辑代理' : '新增代理'" v-model="dialogVisible" width="800px" destroy-on-close>
      <el-form :model="form" :rules="rules" ref="formRef" label-width="140px">
        <!-- 基本信息 -->
        <el-divider content-position="left">基本信息</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="代理名称" prop="agent_name">
              <el-input v-model="form.agent_name" placeholder="请输入代理名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理账号" prop="username">
              <el-input v-model="form.username" placeholder="请输入代理账号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="代理密码" prop="password">
              <el-input type="password" v-model="form.password"
                :placeholder="isEdit ? '不填写则不修改密码' : '请输入密码'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户数量" prop="store_count">
              <el-input-number v-model="form.store_count" :min="0" :disabled="isEdit"
                style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="点数" prop="dianshu">
              <el-input-number v-model="form.dianshu" :min="0" :disabled="isEdit" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过期时间" prop="out_date">
              <el-date-picker v-model="form.out_date" type="date" placeholder="选择日期" format="YYYY-MM-DD"
                value-format="YYYY-MM-DD" style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="是否关闭" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="0">开启</el-radio>
                <el-radio :label="1">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 阿里云 OSS 存储配置 -->
        <el-divider content-position="left">阿里云 OSS 存储配置</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="阿里云ID">
              <el-input v-model="form.aliyun_keyid" placeholder="请输入阿里云 AccessKey ID" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="阿里云密钥">
              <el-input v-model="form.aliyun_secret" placeholder="请输入阿里云 AccessKey Secret" show-password />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="存储地域">
              <el-input v-model="form.endpoint" placeholder="例：oss-cn-shanghai.aliyuncs.com" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="存储桶">
              <el-input v-model="form.aliyun_bucket" placeholder="请输入Bucket名称" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="存储类型">
              <el-select v-model="form.storage_type" placeholder="请选择存储类型" style="width: 100%">
                <el-option label="阿里云 OSS" value="aliyun" />
                <el-option label="腾讯云 COS" value="tencent" disabled />
                <el-option label="七牛云 Kodo" value="qiniu" disabled />
                <el-option label="S3 系列存储" value="s3" disabled />
              </el-select>
              <div class="form-tip">其他存储类型即将开放，敬请期待</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="允许使用上级OSS">
              <el-switch v-model="form.allow_parent_oss" :active-value="1" :inactive-value="0" active-text="允许"
                inactive-text="禁止" />
              <div class="form-tip">开启后，当自有OSS配置不完整时，将自动使用上级的OSS配置</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 腾讯地图配置 -->
        <el-divider content-position="left">腾讯地图配置</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="地图KEY">
              <el-input v-model="form.tencent_map_key" placeholder="请输入腾讯地图 KEY" />
              <div class="form-tip">在腾讯位置服务控制台获取</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地图SK">
              <el-input v-model="form.tencent_map_sk" placeholder="请输入腾讯地图 SK（可选）" show-password />
              <div class="form-tip">用于签名校验，可不填</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="地图类型">
              <el-select v-model="form.map_type" placeholder="请选择地图类型" style="width: 100%">
                <el-option label="腾讯地图" value="tencent" />
                <el-option label="百度地图" value="baidu" disabled />
                <el-option label="高德地图" value="amap" disabled />
                <el-option label="天地图" value="tianditu" disabled />
              </el-select>
              <div class="form-tip">其他地图类型即将开放，敬请期待</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="允许使用上级地图">
              <el-switch v-model="form.allow_parent_map" :active-value="1" :inactive-value="0" active-text="允许"
                inactive-text="禁止" />
              <div class="form-tip">开启后，当自有地图KEY不完整时，将自动使用上级的地图配置</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- AI接口配置 -->
        <el-divider content-position="left">AI接口配置</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="AI绘图密钥">
              <el-input v-model="form.ai_draw_key" placeholder="请输入AI绘图/视频接口密钥" show-password />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="允许使用上级AI绘图">
              <el-switch v-model="form.ai_allow_parent_draw" :active-value="1" :inactive-value="0" active-text="允许"
                inactive-text="禁止" />
              <div class="form-tip">开启后，将优先使用上级的AI绘图配置</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="AI服务商">
              <el-select v-model="form.ai_provider" placeholder="请选择AI服务商" style="width: 100%"
                @change="onProviderChange">
                <el-option label="DeepSeek" value="deepseek" />
                <el-option label="通义千问" value="tongyi" />
                <el-option label="自定义" value="custom" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="AI接口地址">
              <el-input v-model="form.ai_api_url" placeholder="请输入API接口地址" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="AI模型名称">
              <el-input v-model="form.ai_model" placeholder="请输入模型名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="AI密钥">
              <el-input v-model="form.ai_api_key" placeholder="请输入API密钥" show-password />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最大令牌数">
              <el-input-number v-model="form.ai_max_tokens" :min="1" :max="32000" :step="512" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="温度参数">
              <el-slider v-model="form.ai_temperature" :min="0" :max="2" :step="0.01" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="允许使用上级AI">
              <el-switch v-model="form.ai_allow_parent" :active-value="1" :inactive-value="0" active-text="允许"
                inactive-text="禁止" />
              <div class="form-tip">开启后，将优先使用上级的AI对话配置</div>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 微信支付服务商配置 -->
        <el-divider content-position="left">微信支付服务商配置</el-divider>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="服务商商户全称">
              <el-input v-model="form.merchant_full_name" placeholder="请输入服务商商户全称（与微信支付登记一致）" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="服务商应用ID">
              <el-input v-model="form.wx_partner_appid" placeholder="请输入服务商小程序/公众号AppId" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务商商户号">
              <el-input v-model="form.wx_partner_mchid" placeholder="请输入微信支付服务商商户号" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="证书序列号">
              <el-input v-model="form.wx_partner_serial_no" placeholder="请输入证书序列号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="APIv3密钥">
              <el-input v-model="form.wx_partner_api_v3_key" placeholder="请输入APIv3密钥" show-password />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商户私钥(PEM)">
              <el-input v-model="form.wx_partner_private_key_path" type="textarea" :rows="3"
                placeholder="请输入商户私钥内容（PEM格式）" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商户证书(PEM)">
              <el-input v-model="form.wx_partner_cert_path" type="textarea" :rows="3" placeholder="请输入商户证书内容（PEM格式）" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>

    <!-- 充值弹窗 -->
    <el-dialog title="充值" v-model="dialogRechargeVisible" width="500px">
      <div style="color: red; font-size: 10px; font-weight: bold; margin-bottom: 10px;margin-left: 22px;">
        充值成功后，无法撤回，请慎重充值！
      </div>
      <el-form :model="rechargeForm" :rules="rechargeRules" ref="rechargeFormRef" label-width="100px">
        <el-form-item label="充值类型" prop="recharge_type">
          <el-select v-model="rechargeForm.recharge_type" placeholder="请选择充值类型">
            <el-option label="商户数量" value="store_count"></el-option>
            <el-option label="点数" value="dianshu"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值数量" prop="amount">
          <el-input-number v-model="rechargeForm.amount" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogRechargeVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRecharge">充值</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';
import config from '@/config.js';
import dayjs from 'dayjs';
import { auth } from '@/utils/auth.js';

export default {
  name: 'AgentManagement',
  setup() {
    const searchForm = reactive({
      agent_name: '',
      username: '',
    });

    const tableData = ref([]);
    const loading = ref(false);
    const submitting = ref(false);

    const pagination = reactive({
      currentPage: 1,
      pageSize: 15,
      total: 0,
    });

    const dialogVisible = ref(false);
    const isEdit = ref(false);
    const formRef = ref(null);

    const dialogRechargeVisible = ref(false);
    const rechargeFormRef = ref(null);
    const selectedUserId = ref(null);

    const form = reactive({
      id: '',
      agent_name: '',
      store_count: 0,
      username: '',
      password: '',
      dianshu: 0,
      status: 0,
      out_date: '',
      // OSS配置
      aliyun_keyid: '',
      aliyun_secret: '',
      endpoint: '',
      aliyun_bucket: '',
      storage_type: 'aliyun',
      allow_parent_oss: 1,
      // 地图配置
      tencent_map_key: '',
      tencent_map_sk: '',
      map_type: 'tencent',
      allow_parent_map: 1,
      // AI配置
      ai_draw_key: '',
      ai_allow_parent_draw: 1,
      ai_provider: 'deepseek',
      ai_api_url: '',
      ai_model: '',
      ai_api_key: '',
      ai_max_tokens: 2048,
      ai_temperature: 0.8,
      ai_allow_parent: 1,
      // 微信支付配置
      merchant_full_name: '',
      wx_partner_appid: '',
      wx_partner_mchid: '',
      wx_partner_serial_no: '',
      wx_partner_api_v3_key: '',
      wx_partner_private_key_path: '',
      wx_partner_cert_path: '',
    });

    // 动态校验规则
    const rules = computed(() => ({
      agent_name: [
        { required: true, message: '请输入代理名称', trigger: 'blur' }
      ],
      store_count: [
        { required: true, message: '请输入商户数量', trigger: 'blur' }
      ],
      username: [
        { required: true, message: '请输入代理账号', trigger: 'blur' },
        { min: 6, message: '代理账号至少6位', trigger: 'blur' }
      ],
      password: [
        { required: !isEdit.value, message: '请输入代理密码', trigger: 'blur' },
        { min: 6, message: '代理密码至少6位', trigger: 'blur' }
      ],
      dianshu: [
        { required: true, message: '请输入点数', trigger: 'blur' }
      ],
      status: [
        { required: true, message: '请选择是否关闭', trigger: 'change' }
      ],
      out_date: [
        { required: true, message: '请选择过期时间', trigger: 'change' }
      ],
    }));

    const rechargeForm = reactive({
      recharge_type: '',
      amount: ''
    });

    const rechargeRules = {
      recharge_type: [{ required: true, message: '请选择充值类型', trigger: 'blur' }],
      amount: [
        { required: true, message: '请输入充值数量', trigger: 'blur' },
        { type: 'number', message: '数量必须是数字', trigger: 'blur' }
      ],
    };

    const user = auth.getStoredUser();
    if (!user) {
      ElMessage.error('未检测到登录用户信息，请重新登录');
    }

    const handleQuery = () => {
      pagination.currentPage = 1;
      fetchData();
    };

    const handleReset = () => {
      searchForm.agent_name = '';
      searchForm.username = '';
      pagination.currentPage = 1;
      fetchData();
    };

    const fetchData = async () => {
      loading.value = true;
      try {
        const response = await axios.post(`${config.BASE_URL}/agent/api/agents_api.php`, {
          action: 'query',
          operator_username: user.username,
          agent_name: searchForm.agent_name,
          username_search: searchForm.username,
          page: pagination.currentPage,
          pageSize: pagination.pageSize,
        });

        if (response.data.success) {
          tableData.value = response.data.data || [];
          pagination.total = response.data.total || 0;
        } else {
          ElMessage.error(response.data.message || '查询失败');
        }
      } catch (error) {
        console.error('查询失败:', error);
        ElMessage.error('查询失败，请检查网络或后端接口');
      } finally {
        loading.value = false;
      }
    };

    const handleSizeChange = (size) => {
      pagination.pageSize = size;
      fetchData();
    };

    const handleCurrentChange = (page) => {
      pagination.currentPage = page;
      fetchData();
    };

    const resetForm = () => {
      form.id = '';
      form.agent_name = '';
      form.store_count = 0;
      form.username = '';
      form.password = '';
      form.dianshu = 0;
      form.status = 0;
      form.out_date = '';
      // OSS配置
      form.aliyun_keyid = '';
      form.aliyun_secret = '';
      form.endpoint = '';
      form.aliyun_bucket = '';
      form.storage_type = 'aliyun';
      form.allow_parent_oss = 1;
      // 地图配置
      form.tencent_map_key = '';
      form.tencent_map_sk = '';
      form.map_type = 'tencent';
      form.allow_parent_map = 1;
      // AI配置
      form.ai_draw_key = '';
      form.ai_allow_parent_draw = 1;
      form.ai_provider = 'deepseek';
      form.ai_api_url = '';
      form.ai_model = '';
      form.ai_api_key = '';
      form.ai_max_tokens = 2048;
      form.ai_temperature = 0.8;
      form.ai_allow_parent = 1;
      // 微信支付配置
      form.merchant_full_name = '';
      form.wx_partner_appid = '';
      form.wx_partner_mchid = '';
      form.wx_partner_serial_no = '';
      form.wx_partner_api_v3_key = '';
      form.wx_partner_private_key_path = '';
      form.wx_partner_cert_path = '';
    };

    const showAddModal = () => {
      isEdit.value = false;
      resetForm();
      dialogVisible.value = true;
    };

    const showEditModal = (row) => {
      isEdit.value = true;
      resetForm();
      Object.assign(form, {
        id: row.id,
        agent_name: row.agent_name || '',
        store_count: Number(row.store_count) || 0,
        username: row.username || '',
        password: '',
        dianshu: Number(row.dianshu) || 0,
        status: Number(row.status),
        out_date: row.out_date || '',
        // OSS配置
        aliyun_keyid: row.aliyun_keyid || '',
        aliyun_secret: row.aliyun_secret || '',
        endpoint: row.endpoint || '',
        aliyun_bucket: row.aliyun_bucket || '',
        storage_type: row.storage_type || 'aliyun',
        allow_parent_oss: Number(row.allow_parent_oss) || 1,  // 转换数字
        // 地图配置
        tencent_map_key: row.tencent_map_key || '',
        tencent_map_sk: row.tencent_map_sk || '',
        map_type: row.map_type || 'tencent',
        allow_parent_map: Number(row.allow_parent_map) || 1,  // 转换数字
        // AI配置
        ai_draw_key: row.ai_draw_key || '',
        ai_allow_parent_draw: Number(row.ai_allow_parent_draw) || 1,  // 转换数字
        ai_provider: row.ai_provider || 'deepseek',
        ai_api_url: row.ai_api_url || '',
        ai_model: row.ai_model || '',
        ai_api_key: row.ai_api_key || '',
        ai_max_tokens: Number(row.ai_max_tokens) || 2048,  // 转换数字
        ai_temperature: Number(row.ai_temperature) || 0.8,  // 转换数字（关键）
        ai_allow_parent: Number(row.ai_allow_parent) || 1,  // 转换数字
        // 微信支付配置
        merchant_full_name: row.merchant_full_name || '',
        wx_partner_appid: row.wx_partner_appid || '',
        wx_partner_mchid: row.wx_partner_mchid || '',
        wx_partner_serial_no: row.wx_partner_serial_no || '',
        wx_partner_api_v3_key: row.wx_partner_api_v3_key || '',
        wx_partner_private_key_path: row.wx_partner_private_key_path || '',
        wx_partner_cert_path: row.wx_partner_cert_path || '',
      });
      dialogVisible.value = true;
    };

    // AI服务商切换时自动填充默认接口地址和模型名称
    const onProviderChange = () => {
      const defaults = {
        deepseek: {
          url: 'https://api.deepseek.com/v1/chat/completions',
          model: 'deepseek-chat'
        },
        tongyi: {
          url: 'https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions',
          model: 'qwen-plus'
        },
        custom: {
          url: '',
          model: ''
        }
      };

      const selected = defaults[form.ai_provider];
      if (selected) {
        form.ai_api_url = selected.url;
        form.ai_model = selected.model;
      }
    };

    const showRechargeModal = (row) => {
      selectedUserId.value = row.id;
      rechargeForm.recharge_type = '';
      rechargeForm.amount = '';
      dialogRechargeVisible.value = true;
    };

    const submitForm = () => {
      formRef.value.validate(async (valid) => {
        if (valid) {
          submitting.value = true;
          let action = isEdit.value ? 'update' : 'add';
          let payload = {
            action,
            operator_username: user.username,
            agent_name: form.agent_name,
            store_count: form.store_count,
            username: form.username,
            dianshu: form.dianshu,
            status: Number(form.status),
            out_date: form.out_date,
            // OSS配置
            aliyun_keyid: form.aliyun_keyid,
            aliyun_secret: form.aliyun_secret,
            endpoint: form.endpoint,
            aliyun_bucket: form.aliyun_bucket,
            storage_type: form.storage_type,
            allow_parent_oss: form.allow_parent_oss,
            // 地图配置
            tencent_map_key: form.tencent_map_key,
            tencent_map_sk: form.tencent_map_sk,
            map_type: form.map_type,
            allow_parent_map: form.allow_parent_map,
            // AI配置
            ai_draw_key: form.ai_draw_key,
            ai_allow_parent_draw: form.ai_allow_parent_draw,
            ai_provider: form.ai_provider,
            ai_api_url: form.ai_api_url,
            ai_model: form.ai_model,
            ai_api_key: form.ai_api_key,
            ai_max_tokens: form.ai_max_tokens,
            ai_temperature: form.ai_temperature,
            ai_allow_parent: form.ai_allow_parent,
            // 微信支付配置
            merchant_full_name: form.merchant_full_name,
            wx_partner_appid: form.wx_partner_appid,
            wx_partner_mchid: form.wx_partner_mchid,
            wx_partner_serial_no: form.wx_partner_serial_no,
            wx_partner_api_v3_key: form.wx_partner_api_v3_key,
            wx_partner_private_key_path: form.wx_partner_private_key_path,
            wx_partner_cert_path: form.wx_partner_cert_path,
          };

          if (isEdit.value) {
            payload.id = form.id;
            if (form.password) {
              payload.password = form.password;
            }
          } else {
            payload.password = form.password;
          }

          try {
            const response = await axios.post(`${config.BASE_URL}/agent/api/agents_api.php`, payload);
            if (response.data.success) {
              ElMessage.success(isEdit.value ? '编辑成功' : '新增成功');
              dialogVisible.value = false;
              fetchData();
            } else {
              ElMessage.error(response.data.message || (isEdit.value ? '编辑失败' : '新增失败'));
            }
          } catch (error) {
            console.error('提交失败:', error);
            ElMessage.error(isEdit.value ? '编辑失败' : '新增失败');
          } finally {
            submitting.value = false;
          }
        }
      });
    };

    const submitRecharge = () => {
      rechargeFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            const response = await axios.post(`${config.BASE_URL}/agent/api/agents_api.php`, {
              action: 'recharge',
              operator_username: user.username,
              user_id: selectedUserId.value,
              recharge_type: rechargeForm.recharge_type,
              amount: Number(rechargeForm.amount),
            });

            if (response.data.success) {
              ElMessage.success('充值成功');
              dialogRechargeVisible.value = false;
              fetchData();
            } else {
              ElMessage.error(response.data.message || '充值失败');
            }
          } catch (error) {
            console.error('充值失败:', error);
            ElMessage.error('充值失败');
          }
        }
      });
    };

    const dateFormatter = (row, column, cellValue) => {
      if (!cellValue) return '';
      return dayjs(cellValue).format('YYYY-MM-DD');
    };

    const datetimeFormatter = (row, column, cellValue) => {
      if (!cellValue) return '';
      return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss');
    };

    const is_openFormatter = (row) => {
      return Number(row.status) === 0 ? '开启' : '关闭';
    };

    onMounted(() => {
      fetchData();
    });

    return {
      searchForm,
      tableData,
      loading,
      submitting,
      pagination,
      dialogVisible,
      isEdit,
      form,
      rules,
      formRef,
      rechargeForm,
      rechargeRules,
      rechargeFormRef,
      dialogRechargeVisible,
      handleQuery,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      showAddModal,
      showEditModal,
      showRechargeModal,
      submitForm,
      submitRecharge,
      dateFormatter,
      datetimeFormatter,
      is_openFormatter,
      onProviderChange
    };
  },
};
</script>

<style scoped>
.agent-management {
  padding: 1px;
}

.mb-4 {
  margin-bottom: 20px;
}

.toolbar {
  margin-bottom: 10px;
}

.pagination-wrap {
  margin-top: 10px;
  text-align: right;
}

.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  line-height: 1.4;
}

.section-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>